// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBLDDSMGC-9FEsrRQXsIOJ8_vKySohh-F8",
  authDomain: "webstore-bc754.firebaseapp.com",
  projectId: "webstore-bc754",
  storageBucket: "webstore-bc754.firebasestorage.app",
  messagingSenderId: "884339247019",
  appId: "1:884339247019:web:211a9f1e6f4c2b2436b4ee",
  measurementId: "G-6JQFLVQJ6V"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export { app, analytics };
